module.exports = __webpack_public_path__ + "img/galerie-13.5819142f.jpg";